import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faEdit,
  faFileExport,
  faLightbulb,
  faInfoCircle,
  faPlus,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faTimes,
  faTrash,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import { faObjectGroup } from '@fortawesome/free-regular-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
declare var $: any;

@Component({
  selector: 'app-environment-mapper',
  templateUrl: './environment-mapper.component.html',
  styleUrls: ['./environment-mapper.component.scss'],
})
export class EnvironmentMapperComponent implements OnInit {
  /// Icons
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faLightbulb = faLightbulb;
  faCircle = faCircle;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faPlus = faPlus;
  faTimes = faTimes;
  faTrash = faTrash;
  faObjectGroup = faObjectGroup;
  faEdit = faEdit;
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  syncModelDataObject: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private reloadToolService: ReloadToolService,
    private appService: AppService,
    public mainComponent: MainComponent
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });

  }

  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  modelData: any;
  /// app open
  listOfEnv: any;
  envMap: any;
  environmentModel: any;
  /// app close
  /// model open
  /// model close
  /// controller open
  //  this.AppService = AppService;
  //this variable holds the value of the choosen environment from the drop down
  selectedEnvironment: any = {
    envList: [],
    envName: '',
    envId: '',
    envTypes: [],
  };
  //set the value of text box in the drop down hidden and the drop down visible
  showText: any = false;
  //set the value for the icon of add as false -> making the update button visible
  new: any = true;
  //variable holds the index of list of env you wanna make combinations with
  selectedEnv: any = [];
  selectEnvSubstr: any = '';
  updateEnvname: any = false;
  environmentName: any = '';
  oldEnvName: any;
  toastMsgPopup: any;
  textareaParsed: any = [];
  /// controller close

  ngOnInit(): void {
    setTimeout(() => {
      this.getVideoURL('Ed')
    }, 2000);
    this.selectedEnvironment = {
      envList: [],
      envName: '',
      envId: '',
      envTypes: [],
    };
    this.selectedEnvironment.envList = [];
    // this.changeAxisTab('yAxis');
    this.modelData = this._sharedService.loadedProjectData.model;
    this.listOfEnv = this.modelData.listOfEnv;
    this.envMap = this.modelData.envMap;
    this.environmentModel = this.modelData.environmentModel;
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
  }

  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "RECON");
    setTimeout(() => {
      // if (this.choosenEUT) {
      //   this.loadEntityDetails(this.choosenEUT);
      // }
    }, 500);
  }
  parseTextArea(text: any, model: any, id: any) {
    var str = text.toString();
    this.textareaParsed = str.split(',');
    this.listOfEnv[id].envValues = this.textareaParsed;
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  /// controller fn open

  //function is called when clicked on any environment from the drop down
  chooseEnvironment(newButton: any, textBox: any, environment: any) {
    this.new = newButton;
    this.showText = textBox;
    if (environment != '') {
      this.selectedEnvironment = environment;
    } else {
      this.selectedEnvironment = {
        envList: [],
        envName: '',
        envId: '',
        envTypes: [],
      };
    }

    this.environmentName = environment.envName;
    this.selectedEnv = [];
    if (this.selectedEnvironment.envName) {
      var envSubstr = this.selectedEnvironment.envName.substring(0, 2);
      this.selectEnvSubstr = envSubstr.toUpperCase();
    }
  }

  addEnvironment(name: any) {
    var newname = name.trim();
    if (newname === undefined || newname === '') {
      this.triggerToastPopup("Please enter environment name");
      return;
    }
    for (let j = 0; j < this.envMap.length; j++) {
      if (this.envMap[j].envName.toUpperCase() == newname.toUpperCase()) {
        this.triggerToastPopup("Sorry, an environment with this name exists! Please use a different name.");
        return;
      }
    }
    var envMapObject = {
      envName: newname,
      envTypes: [],
      envList: [],
      envId: this.uuidv4(),
    }
    this.envMap.push(envMapObject);
    this.syncModelDataObject = {
      "type": "EMAP",
      "operation": "CREATE",
      "data": envMapObject
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.new = false;
    this.showText = false;
    var env = this.envMap.find(
      (environment: any) => environment.envName == newname
    );
    this.selectedEnvironment = env;
    this.environmentName = env.envName;
  }

  editEnvironment(oldName: any) {
    this.showText = true;
    this.updateEnvname = true;
    this.oldEnvName = oldName;
  }

  saveEnvironment(newname: any, oldname: any, updateEnvironment: any) {
    if (this.new) {
      this.addEnvironment(newname);
      this.selectedEnv = [];
    } else {
      for (let i = 0; i < this.envMap.length; i++) {
        if (this.envMap[i].envName.toUpperCase() == newname.toUpperCase()) {
          this.triggerToastPopup(this.appService.getResourceText('V025'));
          return;
        }
      }
      var environmentUpdate = this.envMap.find(
        (env: any) => env.envId == this.selectedEnvironment.envId
      );
      environmentUpdate.envName = newname;
      this.new = false;
      this.showText = false;
    }
  }

  deleteEnvironment() {
    var controller = this;
    var index = this.envMap.findIndex(
      (environment: any) =>
        environment.envId == controller.selectedEnvironment.envId
    );
    if (index) {
      this.envMap.splice(index, 1);
    }
    var envID = controller.selectedEnvironment.envId;
    this.syncModelDataObject = {
      "type": "EMAP",
      "operation": "DELETE",
      "data": this.selectedEnvironment
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    if (index == 0) {
      this.envMap.shift();
    }
    setTimeout(() => {
      this.selectedEnvironment = {
        envList: [],
        envName: '',
        envId: '',
        envTypes: [],
      };
    }, 500);
  
    this.new = true;
    this.showText = false;
  }

  clear() {
    this.showText = false;
    if (this.updateEnvname == true) {
      this.selectedEnvironment.envName = this.oldEnvName;
      this.chooseEnvironment(false, false, this.selectedEnvironment);
      this.updateEnvname = false;
    } else if (this.updateEnvname == false) {
      this.selectedEnvironment = {
        envList: [],
        envName: '',
        envId: '',
        envTypes: [],
      };
      this.selectedEnv = [];
    }
  }

  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    $('#environmentMsgPopup').modal('toggle');
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  addForGeneration(checkBox: any, index: any, env: any) {
    var controller = this;
    var newIndex = this.selectedEnvironment.envTypes.findIndex(
      (e: any) => e == env.envType
    );
    if (newIndex == -1) {
      this.selectedEnvironment.envTypes.push(env.envType);
      this.generateEnvironmentCombinations();
    } else if (newIndex > -1) {
      this.selectedEnvironment.envTypes.splice(newIndex, 1);
      this.generateEnvironmentCombinations();
    }
    var envSubstr = this.selectedEnvironment.envName.substring(0, 2);
    this.selectEnvSubstr = envSubstr.toUpperCase();
  }

  //function that will generate all-pairs combinations of the environments when clicked on generate
  generateEnvironmentCombinations() {
    if (this.selectedEnvironment.envTypes) {
      if (
        this.selectedEnvironment.envTypes.length > 0 &&
        this.selectedEnvironment.envName != ''
      ) {
        // {
        var results = [[]];
        for (var i = 0; i < this.selectedEnvironment.envTypes.length; i++) {
          // console.log('Type', this.selectedEnvironment.envTypes[i]);
          var en = this.listOfEnv.find(
            (e: any) => e.envType == this.selectedEnvironment.envTypes[i]
          );
          if (en) {
            // console.log('en', en);
            var currentSubArray = en.envValues;
            var temp = [];
            for (var j = 0; j < results.length; j++) {
              for (var k = 0; k < currentSubArray.length; k++) {
                if (i == this.selectedEnvironment.envTypes.length - 1) {
                  temp.push(results[j] + currentSubArray[k].trim());
                } else {
                  temp.push(results[j] + currentSubArray[k].trim() + ',');
                }
              }
            }
            results = temp;
          }
        }
        this.selectedEnvironment.envList = results.slice(0);
      } else if (this.selectedEnvironment.envTypes.length == 0) {
        this.selectedEnvironment.envList = [];
      }
    }
    this.syncModelDataObject = {
      "type": "EMAP",
      "operation": "UPDATE",
      "data": this.selectedEnvironment
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.selectedEnvironment",this.selectedEnvironment);
  }

  add(newEnv: any, id: any) {
    this.addEnv(newEnv, id);
  }

  delete(id: any) {
    this.deleteEnv(id);
  }
  //Function to clear th empty Env Type
  onFocusOutEnv(model: any, id: any) {
    this.parseTextArea(this.listOfEnv[id].envValues, model, id);
    // if (!model) {
    //     this.delete(id);
    // }
    this.generateEnvironmentCombinations();
  }
  //Function to clear th empty list
  onFocusOut(model: any, id: any) {
    if (!model) {
      this.deleteEnVal(id);
    }
  }
  addEnvCombo() {
    this.selectedEnvironment.envList.push(' ');
  }

  addEnVal(envCombo: any, id: any) {
    var newID = id + 1;
    this.selectedEnvironment.envList.splice(newID, 0, envCombo);
  }

  deleteEnVal(id: any) {
    if (id >= 0) {
      return this.selectedEnvironment.envList.splice(id, 1);
    }
  }

  isChecked(environment: any) {
    if (this.selectedEnvironment.envName != undefined && !this.showText) {
      var env = this.selectedEnvironment.envTypes.findIndex(
        (anEnvironment: any) => anEnvironment == environment.envType
      );
      return env > -1 ? true : false;
    } else {
      return false;
    }
  }

  generateReport(auto: any) {
    let mapperArray = ['EnvironmentMapper'];
    window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    window.localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  /// controller fn close
  //adding  a new environment
  //id will be the position at which we want to add a new environment
  addEnv(newEnvironment: any, id: any) {
    var newEnvironment: any = {
      //eid is the unique id generated for an environment,etype being the type ->tf,bf,fl
      envID: this.uniqueEnvID(),
      envType: newEnvironment,
      envValues: [],
    };
    var newID = id + 1;
    this.listOfEnv.unshift(newEnvironment);
    // this.environments.splice(newID, 0, newEnvironment);
  }

  // delete a environment
  // id is the index of the
  deleteEnv(id: any) {
    if (id >= 0) {
      return this.listOfEnv.splice(id, 1);
    }
  }

  //gets the list of environments
  get() {
    return this.listOfEnv;
  }

  //search the environment list
  //currently we can search only based on environment id(which has to be included)
  //id here is the unique id given to every environment
  search(id: any) {
    var environment = this.listOfEnv.find(
      (environment: any) => environment.envID == id
    );
    return environment;
  }

  //generation of unique id for an environment
  uniqueEnvID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      'E' +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }

  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }
}
